import styled from 'styled-components'

const OfflineOffer = styled.span`
  font-size: small;
  padding: 8px;
`

const WrapText = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

const WarpInfo = styled.div`
  display: block;
`

export { OfflineOffer, WarpInfo, WrapText }
